import React from 'react';
import ContactForm from './ContactForm';
import { useLanguage } from '../i18n/LanguageContext';

const Contact = () => {
  const { dict } = useLanguage();
  const c = dict.contact;

  return (
    <section id="contact" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-2 text-black">{c.title}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{c.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-5xl mx-auto items-start">
          <div>
            <h3 className="text-xl font-bold text-purple-800 mb-4">{c.nextTitle}</h3>
            <ul className="space-y-4 text-gray-700 mb-8">
              {c.nextSteps.map((step, index) => (
                <li key={index} className="flex items-start">
                  <span className="mt-1 mr-3 text-purple-600" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ul>
            <p className="text-sm text-gray-500">
              {c.preferEmail}{' '}
              <a href="mailto:jpaul@trabbit.io" className="text-purple-700 font-medium hover:text-purple-900">
                jpaul@trabbit.io
              </a>
            </p>
          </div>

          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
